import React, {Component} from 'react';
import IntakeFormRadTextEnum from "./enum/IntakeFormRadTextEnum";
import FormField from "../../../components/form/FormField";
import {TextInput} from "../../../components";

class IntakeFormRadReferralInformation extends Component {
    render() {
        const {
            selectedLanguage, readOnly, onChange, pushFormFieldRef,
            howHeardAboutClinic, referringPhysician, reasonForImaging
        } = this.props

        return (
            <div className="container dim14-form-row-align">
                <h3 className="text-center mb-3">
                    <b>{IntakeFormRadTextEnum.Referral_Information[selectedLanguage]}</b>
                </h3>

                {/* How did you hear about the clinic */}
                <div className="row">
                    <div className="col-4 dim14-form-label">
                        {IntakeFormRadTextEnum.How_Did_You_Hear_About_Clinic[selectedLanguage]}:
                    </div>
                    <div className="col-8">
                        <FormField
                            ref={(formField) => pushFormFieldRef(formField)}
                            required
                            requiredMessage={IntakeFormRadTextEnum.Required_Field[selectedLanguage]}
                            validateOn={readOnly ? true : howHeardAboutClinic}
                        >
                            <TextInput
                                className="w-100"
                                value={howHeardAboutClinic}
                                disabled={readOnly}
                                onChange={(value) => onChange("howHeardAboutClinic", value)}
                            />
                        </FormField>
                    </div>
                </div>

                {/* Referring Physician */}
                <div className="row">
                    <div className="col-4 dim14-form-label">
                        {IntakeFormRadTextEnum.Referring_Physician[selectedLanguage]}:
                    </div>
                    <div className="col-8">
                        <FormField
                            ref={(formField) => pushFormFieldRef(formField)}
                            required
                            requiredMessage={IntakeFormRadTextEnum.Required_Field[selectedLanguage]}
                            validateOn={readOnly ? true : referringPhysician}
                        >
                            <TextInput
                                className="w-100"
                                value={referringPhysician}
                                disabled={readOnly}
                                alphabeticOnly
                                onChange={(value) => onChange("referringPhysician", value)}
                            />
                        </FormField>
                    </div>
                </div>

                {/* Reason for Imaging Exam */}
                <div className="row">
                    <div className="col-4 dim14-form-label">
                        {IntakeFormRadTextEnum.Reason_For_Imaging[selectedLanguage]}:
                    </div>
                    <div className="col-8">
                        <FormField
                            ref={(formField) => pushFormFieldRef(formField)}
                            required
                            requiredMessage={IntakeFormRadTextEnum.Required_Field[selectedLanguage]}
                            validateOn={readOnly ? true : reasonForImaging}
                        >
                            <TextInput
                                className="w-100"
                                value={reasonForImaging}
                                disabled={readOnly}
                                onChange={(value) => onChange("reasonForImaging", value)}
                            />
                        </FormField>
                    </div>
                </div>
            </div>
        );
    }
}

export default IntakeFormRadReferralInformation;